import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import PinLock from "@/components/PinLock";
import DolphinLayout from "@/components/DolphinLayout";
import ProfilesTable from "@/pages/ProfilesTable";
import ProfileEditor from "@/pages/ProfileEditor";
import TelegramConnect from "@/pages/TelegramConnect";
import ImportExport from "@/pages/ImportExport";
import Settings from "@/pages/Settings";
import Extensions from "@/pages/Extensions";
import SchedulePage from "@/pages/SchedulePage";
import CashinoutMainPreview from "@/pages/CashinoutMainPreview";
import CashinoutPreview from "@/pages/CashinoutPreview";
import CashinoutPaymentsPreview from "@/pages/CashinoutPaymentsPreview";
import BetboomPreview from "@/pages/BetboomPreview";
import BetboomPaymentsPreview from "@/pages/BetboomPaymentsPreview";
import NovapayMain from "@/pages/NovapayMain";
import NovapayPersonal from "@/pages/NovapayPersonal";
import NovapayPayments from "@/pages/NovapayPayments";
import OneWinCombinedPreview from "@/pages/OneWinCombinedPreview";

function App() {
  const [unlocked, setUnlocked] = useState(
    () => sessionStorage.getItem("pin_unlocked") === "1"
  );

  // Template routes bypass PIN (used by backend Playwright for screenshots)
  const isTemplateRoute = window.location.pathname.startsWith("/templates/");

  if (!unlocked && !isTemplateRoute) {
    return (
      <div className="h-screen overflow-hidden bg-[#0D0F12]">
        <PinLock onUnlock={() => setUnlocked(true)} />
      </div>
    );
  }

  return (
    <div className="h-screen overflow-hidden bg-[#0D0F12]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<DolphinLayout />}>
            <Route index element={<ProfilesTable />} />
            <Route path="profiles" element={<ProfilesTable />} />
            <Route path="profiles/new" element={<ProfileEditor />} />
            <Route path="profiles/:id" element={<ProfileEditor />} />
            <Route path="telegram" element={<TelegramConnect />} />
            <Route path="import-export" element={<ImportExport />} />
            <Route path="extensions" element={<Extensions />} />
            <Route path="schedule" element={<SchedulePage />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          <Route path="/templates/cashinout/main" element={<CashinoutMainPreview />} />
          <Route path="/templates/cashinout/preview" element={<CashinoutPreview />} />
          <Route path="/templates/cashinout/payments" element={<CashinoutPaymentsPreview />} />
          <Route path="/templates/betboom/preview" element={<BetboomPreview />} />
          <Route path="/templates/betboom/payments" element={<BetboomPaymentsPreview />} />
          <Route path="/templates/novapay/main" element={<NovapayMain />} />
          <Route path="/templates/novapay/personal" element={<NovapayPersonal />} />
          <Route path="/templates/novapay/payments" element={<NovapayPayments />} />
          <Route path="/templates/1win/combined" element={<OneWinCombinedPreview />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors theme="dark" />
    </div>
  );
}

export default App;
